export const formError = {
	440: '參數錯誤，請檢查欄位是否正確',
	490: '帳號重複',
	491: '密碼輸入不一致',
	492: '原密碼輸入錯誤',
	493: '密碼未更改',
	494: '未產生金鑰',
	500: '系統異常',
};

export const dialogWidth = 600;
export const dialogHeight = 480;

export const privilageDialogWidth = 1200;

export const privilageDialogHeight = 600;

export const accountMaxText = 30;

export const userTokenMax = 1000;

export const accountStatusCode: { [key: number]: any } = {
	1: '未認證',
	2: '鎖定',
	3: '開啟',
	4: '關閉',
};
